import React, { useCallback, useMemo, useState } from 'react';
import * as PropTypes from 'prop-types';
import BasicMenu from '@itt/frontend-scaffold-components/dist/BasicMenu/BasicMenu';
import styles from './NavigationMenuItem.module.less';
import dropDownSvg from '../../../../../assets/images/dropdown-arrow.svg';
import dropUpSvg from '../../../../../assets/images/dropup.svg';
import dropDownGreySvg from '../../../../../assets/images/dropdown-arrow-grey.svg';
import dropUpGreySvg from '../../../../../assets/images/dropup-grey.svg';

const NavigationMenuItem = ({ text, icon, menus, className }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = useCallback(
    e => {
      setAnchorEl(e.currentTarget);
    },
    [setAnchorEl]
  );

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, [setAnchorEl]);

  const arrowSvg = useMemo(() => {
    if (className === 'gray') {
      return anchorEl ? dropUpGreySvg : dropDownGreySvg;
    }
    return anchorEl ? dropUpSvg : dropDownSvg;
  }, [anchorEl, className]);

  return (
    <>
      <span
        className={`${styles.item} ${styles[className]}`}
        onClick={handleClick}>
        <img src={icon} alt={icon} className={styles.icon} />
        <span className={styles.name}>{text}</span>
        <img src={arrowSvg} alt={arrowSvg} className={styles.arrow} />
      </span>
      <BasicMenu menus={menus} onClose={handleClose} anchorEl={anchorEl} />
    </>
  );
};

NavigationMenuItem.propTypes = {
  text: PropTypes.string.isRequired,
  icon: PropTypes.any.isRequired,
  menus: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      onMenuItemClick: PropTypes.func.isRequired
    })
  ).isRequired,
  className: PropTypes.string.isRequired
};

export default NavigationMenuItem;
